import ForcedVibrationImg from '../../Images/ForcedVibrationImg.jpg'

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  h3:           { fontSize:'1.05rem', fontWeight:'700', color:'#7B0D0D', marginTop:'22px', marginBottom:'8px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  divider:      { borderTop:'2px solid #c0392b', margin:'40px 0 28px', opacity:0.25 },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── SVG helpers ───────────────────────────────────────────────────
function mkSpring(x0, x1, y, n=8) {
  const cW=(x1-x0)/n, pts=[[x0,y]];
  for(let i=0;i<n;i++){pts.push([x0+i*cW+cW*0.25,y-16]);pts.push([x0+i*cW+cW*0.75,y+16]);}
  pts.push([x1,y]);
  return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
}
function WallV({x,y,h}){
  const ticks=[];for(let ty=y;ty<y+h;ty+=18)ticks.push(ty);
  return(<><rect x={x} y={y} width={12} height={h} fill="#888"/>{ticks.map(ty=>(<line key={ty} x1={x} y1={ty} x2={x-13} y2={ty+14} stroke="#888" strokeWidth="1.5"/>))}</>);
}
function GroundH({x1,x2,y}){
  const ticks=[];for(let tx=x1;tx<=x2;tx+=22)ticks.push(tx);
  return(<><line x1={x1} y1={y} x2={x2} y2={y} stroke="#555" strokeWidth="2"/>{ticks.map(tx=>(<line key={tx} x1={tx} y1={y} x2={tx-12} y2={y+16} stroke="#555" strokeWidth="1.5"/>))}</>);
}
function Damper({x0,x1,y}){
  const cyl=(x1-x0)*0.55;
  return(<>
    <rect x={x0} y={y-12} width={cyl} height={24} rx={4} fill="#ddd" stroke="#999" strokeWidth="1.5"/>
    <rect x={x0+2} y={y-10} width={cyl-4} height={20} rx={3} fill="#b3cde3" opacity="0.7"/>
    <rect x={x0+cyl-5} y={y-13} width={10} height={26} rx={2} fill="#555"/>
    <rect x={x0+cyl+5} y={y-5} width={(x1-x0)*0.45-5} height={10} rx={2} fill="#888"/>
  </>);
}

// ═══════════════════════════════════════════════════════════════════
//  SECTION 5 — FORCED VIBRATION (UNDAMPED)
// ═══════════════════════════════════════════════════════════════════

// ── Diagram 1: Undamped Physical Setup & Solution Structure ───────
function DiagUndampedSetup() {
  const W=900, H=380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Undamped Forced System — Physical Model &amp; Solution Structure</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="u1r" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
          <marker id="u1b" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
          <marker id="u1g" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
        </defs>

        {/* ── LEFT: physical model ──────────────────────── */}
        <rect x={10} y={10} width={310} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={165} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Physical Model  (c = 0)</text>

        <WallV x={18} y={55} h={220}/>
        <path d={mkSpring(30,170,150,8)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={100} y={130} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">k</text>

        {/* mass */}
        <rect x={170} y={110} width={110} height={100} rx={6} fill="#2E75B6" stroke="#1a5276" strokeWidth="2.5"/>
        <text x={225} y={168} textAnchor="middle" fontSize="26" fill="#fff" fontWeight="700">m</text>

        {/* Ground + rollers */}
        <GroundH x1={30} x2={300} y={310}/>
        {[200,240,260].map(cx=>(
          <g key={cx}><circle cx={cx} cy={310} r={12} fill="#888" stroke="#555" strokeWidth="2"/><circle cx={cx} cy={310} r={4} fill="#fff"/></g>
        ))}

        {/* Applied harmonic force */}
        <line x1={280} y1={160} x2={302} y2={160} stroke="#c0392b" strokeWidth="3.5" markerEnd="url(#u1r)"/>
        <text x={230} y={96} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">F(t) = F₀ cos(ωt)</text>
        {/* Sinusoid above mass */}
        {(() => {
          const pts=[];
          for(let i=0;i<=40;i++){const t=i/40*2*Math.PI;pts.push([170+i*3.5, 76-14*Math.cos(t)]);}
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="1.8" opacity="0.7"/>;
        })()}

        {/* x label */}
        <line x1={185} y1={108} x2={280} y2={108} stroke="#2E75B6" strokeWidth="1.8" strokeDasharray="5" markerEnd="url(#u1b)"/>
        <text x={232} y={102} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">x(t)</text>

        {/* EOM box */}
        <rect x={16} y={330} width={298} height={38} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={165} y={348} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">mẍ + kx = F₀ cos(ωt)</text>
        <text x={165} y={363} textAnchor="middle" fontSize="11" fill="#555" fontFamily="'Courier New',monospace">ẍ + ωₙ²x = (F₀/m)cos(ωt)</text>

        {/* ── MIDDLE: solution breakdown ────────────── */}
        <rect x={330} y={10} width={245} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={452} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Solution Structure</text>

        {/* Total = homogeneous + particular */}
        <rect x={336} y={42} width={233} height={36} rx={3} fill="#1a1a2e" opacity="0.06"/>
        <text x={452} y={58} textAnchor="middle" fontSize="12" fill="#1a1a2e" fontWeight="700">x(t) = x_h(t)  +  x_p(t)</text>
        <text x={452} y={72} textAnchor="middle" fontSize="11" fill="#666">homogeneous  +  particular</text>

        {/* x_h box */}
        <rect x={336} y={88} width={233} height={90} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={342} y={106} fontSize="12" fill="#2E75B6" fontWeight="700">Homogeneous  x_h(t)</text>
        <text x={342} y={122} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">mẍ + kx = 0</text>
        <text x={342} y={138} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">x_h = A cos(ωₙt) + B sin(ωₙt)</text>
        <text x={342} y={154} fontSize="11" fill="#555" fontStyle="italic">A,B fixed by initial conditions</text>
        <text x={342} y={170} fontSize="11" fill="#555" fontStyle="italic">Oscillates at ωₙ (free freq.)</text>

        {/* x_p box */}
        <rect x={336} y={188} width={233} height={90} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={342} y={206} fontSize="12" fill="#27ae60" fontWeight="700">Particular  x_p(t)</text>
        <text x={342} y={222} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">x_p = X cos(ωt)</text>
        <text x={342} y={238} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">X = (F₀/k) / (1 − r²)</text>
        <text x={342} y={254} fontSize="11" fill="#555" fontStyle="italic">r = ω/ωₙ  (freq. ratio)</text>
        <text x={342} y={270} fontSize="11" fill="#555" fontStyle="italic">Oscillates at ω (forcing freq.)</text>

        {/* Combined */}
        <rect x={336} y={288} width={233} height={80} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={342} y={306} fontSize="12" fill="#c0392b" fontWeight="700">Complete Solution</text>
        <text x={342} y={322} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">x = A cos(ωₙt) + B sin(ωₙt)</text>
        <text x={342} y={338} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">  + (F₀/k)·cos(ωt)/(1−r²)</text>
        <text x={342} y={354} fontSize="11" fill="#555" fontStyle="italic">Two frequencies present (beats)</text>
        <text x={342} y={368} fontSize="11" fill="#555" fontStyle="italic">Transient dies if damping added</text>

        {/* ── RIGHT: frequency-ratio panel ──────── */}
        <rect x={585} y={10} width={305} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={737} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">r = ω / ωₙ Regimes</text>

        {[
          {y:42,  bg:'#eaf3ff', bc:'#2E75B6',  label:'r ≪ 1  (quasi-static)',
           lines:['Forcing far below natural freq.','X ≈ F₀/k  (static deflection)','Spring stiffness controls response','In phase with force (φ=0°)']},
          {y:142, bg:'#FEF0F0', bc:'#c0392b',  label:'r → 1  (resonance)',
           lines:['X → ∞  (undamped, no limit)','Response grows without bound','Phase jumps 0° → 180° at r=1','Damping essential to limit X']},
          {y:242, bg:'#f0fff4', bc:'#27ae60',  label:'r ≫ 1  (inertia-controlled)',
           lines:['Forcing far above natural freq.','X → 0  (mass cannot follow)','Mass inertia dominates','Out of phase with force (φ=180°)']},
          {y:318, bg:'#fff5e6', bc:'#e07b00',  label:'r = 1 / √2  (static = dynamic)',
           lines:['D(r) = √2 at this point','Amplitude = √2 × static deflection','Used in isolation analysis']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={591} y={y} width={293} height={lines.length*16+30} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={597} y={y+17} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={597} y={y+33+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The undamped forced system has EOM mẍ + kx = F₀cos(ωt). Its complete solution is the sum of two sinusoids: the homogeneous part (at natural frequency ωₙ, set by ICs) and the particular part (at forcing frequency ω, set by the forcing). When ω ≠ ωₙ two different frequencies coexist, producing a beating pattern. The amplitude of the particular solution is controlled entirely by the frequency ratio r = ω/ωₙ.
      </div>
    </div>
  );
}

// ── Diagram 2: Particular + Homogeneous — Beating ─────────────────
function DiagBeating() {
  const W=900, H=360;
  const ωn=2*Math.PI, dt=0.005, tMax=4;

  // Case 1: r=0.8 (beating visible)
  // x_h = -X cos(ωt) term means: if x0=0, ẋ0=0:
  // A = -X_p, B=0 so x_h = -X_p cos(ωn t)
  // x_total = X_p[cos(ωt) - cos(ωn t)]
  const r1=0.8, ω1=r1*ωn;
  const Xp1 = 1/(1-r1*r1);  // F0/k =1
  const ptsTotal1=[], ptsH1=[], ptsP1=[];
  for(let t=0;t<=tMax;t+=dt){
    ptsH1.push([t, -Xp1*Math.cos(ωn*t)]);
    ptsP1.push([t,  Xp1*Math.cos(ω1*t)]);
    ptsTotal1.push([t, Xp1*(Math.cos(ω1*t)-Math.cos(ωn*t))]);
  }

  // Case 2: r=0.95 (near resonance, large beating amplitude)
  const r2=0.95, ω2=r2*ωn;
  const Xp2=1/(1-r2*r2);
  const ptsTotal2=[];
  for(let t=0;t<=tMax;t+=dt) ptsTotal2.push([t, Math.min(Math.max(Xp2*(Math.cos(ω2*t)-Math.cos(ωn*t)),-12),12)]);

  // SVG map for top panel (r=0.8)
  const mx = t => 55+(t/tMax)*490;
  const myTop = y => 110 - y*28;
  const myBot = y => 285 - y*16;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Homogeneous + Particular Solutions &amp; Beating Phenomenon</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="u2ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
        </defs>

        {/* ── TOP: r=0.8, show x_h, x_p, x_total ── */}
        <rect x={10} y={10} width={550} height={165} rx={4} fill="#fff" stroke="#f0cece"/>
        <text x={285} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">r = 0.8  —  x_h (blue) + x_p (green) = x_total (red)  [x₀=0, ẋ₀=0]</text>

        {/* Zero line */}
        <line x1={55} y1={myTop(0)} x2={547} y2={myTop(0)} stroke="#ddd" strokeWidth="1"/>

        {/* x_h */}
        <path d={ptsH1.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${myTop(y).toFixed(1)}`).join(' ')} fill="none" stroke="#2E75B6" strokeWidth="1.8" opacity="0.7" strokeDasharray="6,3"/>
        {/* x_p */}
        <path d={ptsP1.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${myTop(y).toFixed(1)}`).join(' ')} fill="none" stroke="#27ae60" strokeWidth="1.8" opacity="0.7" strokeDasharray="4,2"/>
        {/* x_total */}
        <path d={ptsTotal1.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${myTop(y).toFixed(1)}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Axes */}
        <line x1={53} y1={30} x2={53} y2={162} stroke="#555" strokeWidth="1.5" markerEnd="url(#u2ax)"/>
        <line x1={50} y1={myTop(0)} x2={550} y2={myTop(0)} stroke="#555" strokeWidth="1.5" markerEnd="url(#u2ax)"/>

        {/* Legend */}
        <line x1={570} y1={45} x2={594} y2={45} stroke="#2E75B6" strokeWidth="2" strokeDasharray="6,3"/>
        <text x={598} y={49} fontSize="11" fill="#2E75B6" fontWeight="700">x_h (ωₙ)</text>
        <line x1={570} y1={65} x2={594} y2={65} stroke="#27ae60" strokeWidth="2" strokeDasharray="4,2"/>
        <text x={598} y={69} fontSize="11" fill="#27ae60" fontWeight="700">x_p (ω)</text>
        <line x1={570} y1={85} x2={594} y2={85} stroke="#c0392b" strokeWidth="2.5"/>
        <text x={598} y={89} fontSize="11" fill="#c0392b" fontWeight="700">x_total</text>

        <rect x={564} y={100} width={136} height={72} rx={3} fill="#fafafa" stroke="#f0cece"/>
        <text x={570} y={116} fontSize="11" fill="#7B0D0D" fontWeight="700">r=0.8, F₀/k=1</text>
        <text x={570} y={132} fontSize="10" fill="#444">x_p amp = 1/(1−r²)</text>
        <text x={570} y={148} fontSize="10" fill="#444">= 1/0.36 = 2.78</text>
        <text x={570} y={164} fontSize="10" fill="#555" fontStyle="italic">Two freqs → beating</text>

        {/* ── BOTTOM: r=0.95, large beating ── */}
        <rect x={10} y={185} width={550} height={165} rx={4} fill="#fff" stroke="#f0cece"/>
        <text x={285} y={202} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">r = 0.95  —  Near Resonance: Large Beating Amplitude</text>

        <line x1={55} y1={myBot(0)} x2={547} y2={myBot(0)} stroke="#ddd" strokeWidth="1"/>
        <path d={ptsTotal2.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${myBot(y).toFixed(1)}`).join(' ')} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>

        {/* Beat envelope annotation */}
        {(() => {
          // Beat frequency = |ωn - ω2|, beat period T_beat = 2π/|ωn-ω2|
          const ωdiff=ωn-ω2, Tbeat=2*Math.PI/ωdiff;
          const x1b=mx(Tbeat/2), x2b=mx(Tbeat);
          return (
            <>
              <line x1={mx(0)} y1={myBot(-Xp2*2)} x2={mx(tMax)} y2={myBot(-Xp2*2)} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="6,3" opacity="0.6"/>
              <line x1={mx(0)} y1={myBot(Xp2*2)} x2={mx(tMax)} y2={myBot(Xp2*2)} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="6,3" opacity="0.6"/>
              <line x1={x1b} y1={myBot(-10)} x2={x2b} y2={myBot(-10)} stroke="#e07b00" strokeWidth="1.5" markerEnd="url(#u2ax)"/>
              <line x1={x2b} y1={myBot(-10)} x2={x1b} y2={myBot(-10)} stroke="#e07b00" strokeWidth="1.5" markerEnd="url(#u2ax)"/>
              <text x={(x1b+x2b)/2} y={myBot(-10)-6} textAnchor="middle" fontSize="11" fill="#e07b00" fontWeight="700">T_beat = 2π/|ωₙ−ω|</text>
            </>
          );
        })()}

        <line x1={53} y1={195} x2={53} y2={342} stroke="#555" strokeWidth="1.5" markerEnd="url(#u2ax)"/>
        <line x1={50} y1={myBot(0)} x2={550} y2={myBot(0)} stroke="#555" strokeWidth="1.5" markerEnd="url(#u2ax)"/>
        {[0,1,2,3,4].map(t=>(
          <g key={t}><line x1={mx(t)} y1={342} x2={mx(t)} y2={347} stroke="#555" strokeWidth="1.5"/><text x={mx(t)} y={356} textAnchor="middle" fontSize="10" fill="#888">{t}s</text></g>
        ))}
        <text x={400} y={370} textAnchor="middle" fontSize="12" fill="#555">time (s)</text>

        <rect x={564} y={192} width={136} height={88} rx={3} fill="#fafafa" stroke="#f0cece"/>
        <text x={570} y={208} fontSize="11" fill="#9b59b6" fontWeight="700">r=0.95, F₀/k=1</text>
        <text x={570} y={224} fontSize="10" fill="#444">X_p = 1/(1−0.9025)</text>
        <text x={570} y={240} fontSize="10" fill="#444">    = 10.3 × static!</text>
        <text x={570} y={256} fontSize="10" fill="#555">Beat period:</text>
        <text x={570} y={272} fontSize="10" fill="#555">T_b = 2π/|ωₙ−ω|</text>
      </svg>
      <div style={S.dCaption}>
        When forcing frequency ω ≠ ωₙ, the complete response is a superposition of two sinusoids at different frequencies. This produces a beating pattern — alternating amplification and cancellation — whose beat period T_beat = 2π/|ωₙ−ω| grows longer as ω approaches ωₙ. At r=0.95 the particular amplitude is already 10× the static deflection. Beating is commonly heard in two musical instruments slightly out of tune.
      </div>
    </div>
  );
}

// ── Diagram 3: Resonance — Undamped Response Growth ───────────────
function DiagResonance() {
  const W=900, H=340;
  // At exact resonance (ω=ωn), x0=0,ẋ0=0:
  // x(t) = (F0/(2mωn)) t sin(ωn t)  — linearly growing amplitude
  const ωn=2*Math.PI, dt=0.005, tMax=3;
  const ptsRes=[];
  for(let t=0;t<=tMax;t+=dt){
    const x=(1/(2*ωn))*ωn*t*Math.sin(ωn*t);  // F0/k=1: (F0/k)/(2)*t*ωn*sin... simplified: ωn*t/(2)*sin(ωn*t) with F0/k=1
    ptsRes.push([t,x]);
  }

  // Envelope: ±ωn t/(2) with F0/k=1
  const mx = t => 55+(t/tMax)*490;
  const my = y => 170 - y*38;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Resonance — ω = ωₙ: Linearly Growing Amplitude (Undamped)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="u3ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
          <marker id="u3r"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
        </defs>

        {/* Graph */}
        <rect x={50} y={25} width={500} height={295} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid */}
        {[-3,-2,-1,0,1,2,3].map(v=>(
          <g key={v}>
            <line x1={50} y1={my(v)} x2={552} y2={my(v)} stroke={v===0?"#ccc":"#ebebeb"} strokeWidth={v===0?1.5:0.8}/>
            <text x={44} y={my(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,1,2,3].map(t=>(
          <g key={t}>
            <line x1={mx(t)} y1={25} x2={mx(t)} y2={320} stroke="#ebebeb" strokeWidth="0.8"/>
            <text x={mx(t)} y={334} textAnchor="middle" fontSize="10" fill="#888">{t}s</text>
          </g>
        ))}

        {/* Envelope lines */}
        {[1,-1].map(sign=>{
          const envPts=[];
          for(let t=0;t<=tMax;t+=0.05) envPts.push([t, sign*(ωn*t/2)]);
          return <path key={sign} d={envPts.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${my(y).toFixed(1)}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="7,4" opacity="0.8"/>;
        })}
        <text x={mx(2.6)} y={my(ωn*2.6/2)-8} fontSize="12" fill="#e07b00" fontWeight="700">envelope ∝ t</text>

        {/* Resonance curve */}
        <path d={ptsRes.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${my(y).toFixed(1)}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Axes */}
        <line x1={48} y1={25} x2={48} y2={323} stroke="#555" strokeWidth="1.5" markerEnd="url(#u3ax)"/>
        <line x1={46} y1={my(0)} x2={555} y2={my(0)} stroke="#555" strokeWidth="1.5" markerEnd="url(#u3ax)"/>
        <text x={18} y={170} textAnchor="middle" fontSize="12" fill="#555" transform="rotate(-90,18,170)">x(t)  [F₀/k = 1]</text>
        <text x={400} y={348} textAnchor="middle" fontSize="12" fill="#555">time (s)  —  ω = ωₙ = 2π rad/s</text>

        {/* ── RIGHT panel ─── */}
        <rect x={562} y={10} width={328} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={726} y={28} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Resonance Condition</text>

        {[
          {y:36,  bg:'#FEF0F0', bc:'#c0392b', label:'Resonance definition',
           lines:['ω = ωₙ  (forcing = natural freq.)','Undamped: amplitude → ∞','Even tiny F₀ eventually breaks system']},
          {y:112, bg:'#fff5e6', bc:'#e07b00', label:'Resonance solution',
           lines:['x(t) = (F₀/2mωₙ) t sin(ωₙt)','Amplitude grows linearly with t','Envelope: ±(F₀/2mωₙ)·t']},
          {y:188, bg:'#eaf3ff', bc:'#2E75B6', label:'Phase at resonance',
           lines:['Phase jumps from 0° to 180°','Response lags force by 90° exactly','True for ALL damping values','Key to identifying ωₙ experimentally']},
          {y:264, bg:'#f0fff4', bc:'#27ae60', label:'Physical consequences',
           lines:['Bridges (Tacoma Narrows, 1940)','Aircraft wing flutter','Turbine blade excitation','Avoidance: detune, add damping, isolate']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={568} y={y} width={316} height={lines.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={574} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={574} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        At exact resonance (ω = ωₙ), the standard particular solution breaks down and the resonance solution x(t) = (F₀/2mωₙ)·t·sin(ωₙt) applies. The amplitude grows linearly with time without bound — there is no steady state. In practice, any real system has some damping that eventually limits amplitude, but even light damping can lead to catastrophic response near resonance. The 90° phase lag at resonance is universal and is the standard method for identifying ωₙ experimentally.
      </div>
    </div>
  );
}

// ── Diagram 4: Undamped Frequency Response (D vs r) ───────────────
function DiagUndampedFRF() {
  const W=900, H=340;
  const nPts=500, rMax=2.5;
  const mx = r => 55+(r/rMax)*490;
  const myD = D => 60+(1-Math.min(Math.abs(D),6)/6)*230;

  const pts=[];
  for(let i=0;i<=nPts;i++){
    const r=(i/nPts)*rMax;
    if(Math.abs(1-r*r)<0.015){pts.push(null);continue;}
    pts.push([r, 1/(1-r*r)]);
  }

  // Split at gap
  const segments=[];let cur=[];
  pts.forEach(p=>{if(p===null){if(cur.length)segments.push(cur);cur=[];}else cur.push(p);});
  if(cur.length)segments.push(cur);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Undamped Frequency Response — Dynamic Magnification D(r) = 1/(1−r²)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="u4ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
        </defs>

        {/* Graph */}
        <rect x={50} y={55} width={500} height={240} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid */}
        {[-4,-2,0,1,2,4,6].map(v=>(
          <g key={v}>
            <line x1={50} y1={myD(v)} x2={552} y2={myD(v)} stroke={v===0||v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.8} strokeDasharray={v===1?"6,3":""}/>
            <text x={44} y={myD(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,0.5,1.0,1.5,2.0,2.5].map(r=>(
          <g key={r}>
            <line x1={mx(r)} y1={55} x2={mx(r)} y2={295} stroke={r===1?"#c0392b":"#ebebeb"} strokeWidth={r===1?1.5:0.8} strokeDasharray={r===1?"6,3":""}/>
            <text x={mx(r)} y={310} textAnchor="middle" fontSize="10" fill={r===1?"#c0392b":"#888"}>{r}</text>
          </g>
        ))}
        <text x={mx(1)+4} y={70} fontSize="11" fill="#c0392b" fontWeight="700">r=1  RESONANCE</text>

        {/* Shaded regions */}
        <rect x={50} y={55} width={mx(1)-50} height={240} fill="#fff5f5" opacity="0.4"/>
        <rect x={mx(1)} y={55} width={552-mx(1)} height={240} fill="#f0fff4" opacity="0.4"/>
        <text x={(50+mx(1))/2} y={80} textAnchor="middle" fontSize="11" fill="#c0392b" fontStyle="italic">in-phase (D&gt;0)</text>
        <text x={(mx(1)+552)/2} y={80} textAnchor="middle" fontSize="11" fill="#27ae60" fontStyle="italic">out-of-phase (D&lt;0)</text>

        {/* D=1 reference */}
        <line x1={50} y1={myD(1)} x2={552} y2={myD(1)} stroke="#999" strokeWidth="1.5" strokeDasharray="8,3"/>
        <text x={555} y={myD(1)+4} fontSize="11" fill="#999">D=1</text>

        {/* Curves */}
        {segments.map((seg,si)=>{
          const positive = seg[0][1]>0;
          const d=seg.map(([r,D],i)=>`${i===0?'M':'L'}${mx(r).toFixed(1)},${myD(D).toFixed(1)}`).join(' ');
          return <path key={si} d={d} fill="none" stroke={positive?"#c0392b":"#2E75B6"} strokeWidth="2.5"/>;
        })}

        {/* Asymptote */}
        <line x1={mx(1)} y1={55} x2={mx(1)} y2={295} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" opacity="0.6"/>

        {/* Axes */}
        <line x1={48} y1={55} x2={48} y2={298} stroke="#555" strokeWidth="1.5" markerEnd="url(#u4ax)"/>
        <line x1={46} y1={myD(0)} x2={555} y2={myD(0)} stroke="#555" strokeWidth="1.5" markerEnd="url(#u4ax)"/>
        <text x={18} y={170} textAnchor="middle" fontSize="12" fill="#555" transform="rotate(-90,18,170)">D(r) = X / (F₀/k)</text>
        <text x={300} y={328} textAnchor="middle" fontSize="12" fill="#555">frequency ratio  r = ω / ωₙ</text>

        {/* ── RIGHT panel ─── */}
        <rect x={562} y={10} width={328} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={726} y={28} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">FRF Interpretation</text>

        {[
          {y:36,  bg:'#FEF0F0', bc:'#c0392b', label:'Amplitude formula',
           lines:['X = (F₀/k) · |D(r)|','D(r) = 1 / (1 − r²)','Undamped — no ζ term']},
          {y:112, bg:'#eaf3ff', bc:'#2E75B6', label:'Phase behaviour',
           lines:['r < 1: D > 0 → φ = 0° (in-phase)','r > 1: D < 0 → φ = 180° (out-of-phase)','Phase jumps discontinuously at r=1','(damping smooths this jump)']},
          {y:200, bg:'#f0fff4', bc:'#27ae60', label:'Static limit (r→0)',
           lines:['D → 1  as r → 0','X → F₀/k  (static deflection)','Natural frequency irrelevant','System follows force quasi-statically']},
          {y:276, bg:'#fff5e6', bc:'#e07b00', label:'High frequency (r→∞)',
           lines:['D → 0  as r → ∞','Mass cannot follow fast forcing','Amplitude → 0 (inertia-controlled)','|D| < 1 for r > √2 always']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={568} y={y} width={316} height={lines.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={574} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={574} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The undamped FRF D(r) = 1/(1−r²) has a vertical asymptote at r=1 (resonance) and a phase discontinuity there. For r &lt; 1 the response is in phase with the force (positive D); for r &gt; 1 it is 180° out of phase (negative D, plotted below axis). Adding any damping replaces the asymptote with a finite peak and smooths the phase discontinuity into a continuous transition through 90° at resonance.
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════
//  SECTION 6 — FORCED VIBRATION WITH DAMPING
// ═══════════════════════════════════════════════════════════════════

// ── Diagram 5: Damped FRF — Amplitude & Phase ─────────────────────
function DiagDampedFRF() {
  const W=900, H=400;
  const ζs=[{z:0.05,c:'#9b59b6'},{z:0.1,c:'#c0392b'},{z:0.3,c:'#e07b00'},{z:0.7,c:'#27ae60'},{z:1.0,c:'#2E75B6'}];
  const nPts=400, rMax=2.5;

  const D  = (r,z) => 1/Math.sqrt((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r));
  const phi= (r,z) => Math.atan2(2*z*r,1-r*r);

  const mxF = r => 55+(r/rMax)*430;
  const myA = D => 52+(1-Math.min(D,8)/8)*195;
  const myP = p => 278+(p/Math.PI)*90;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Damped Frequency Response — Amplitude Ratio D(r,ζ) and Phase φ(r,ζ)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="d5ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
        </defs>

        {/* ── AMPLITUDE ──────────────────────────── */}
        <rect x={50} y={45} width={445} height={210} rx={3} fill="#fafafa" stroke="#ddd"/>
        <text x={272} y={38} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Amplitude Ratio  D = X / (F₀/k)</text>

        {/* Grid amplitude */}
        {[0,1,2,4,6,8].map(v=>(
          <g key={v}>
            <line x1={50} y1={myA(v)} x2={497} y2={myA(v)} stroke={v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.8} strokeDasharray={v===1?"5,3":""}/>
            <text x={44} y={myA(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,0.5,1,1.5,2,2.5].map(r=>(
          <line key={r} x1={mxF(r)} y1={45} x2={mxF(r)} y2={255} stroke={r===1?"#c0392b":"#ebebeb"} strokeWidth={r===1?1.5:0.8} strokeDasharray={r===1?"6,3":""}/>
        ))}
        <text x={mxF(1)+3} y={58} fontSize="10" fill="#c0392b">r=1</text>
        <line x1={50} y1={myA(1)} x2={497} y2={myA(1)} stroke="#aaa" strokeWidth="1" strokeDasharray="5,3"/>

        {/* Amplitude curves */}
        {ζs.map(({z,c})=>{
          const d=Array.from({length:nPts+1},(_,i)=>{const r=i/nPts*rMax;return [r,D(r,z)];})
            .map(([r,v],i)=>`${i===0?'M':'L'}${mxF(r).toFixed(1)},${myA(v).toFixed(1)}`).join(' ');
          return <path key={z} d={d} fill="none" stroke={c} strokeWidth="2"/>;
        })}

        {/* Axes amplitude */}
        <line x1={48} y1={45} x2={48} y2={257} stroke="#555" strokeWidth="1.5" markerEnd="url(#d5ax)"/>
        <line x1={46} y1={myA(0)} x2={500} y2={myA(0)} stroke="#555" strokeWidth="1.5"/>
        <text x={18} y={155} textAnchor="middle" fontSize="11" fill="#555" transform="rotate(-90,18,155)">D(r,ζ)</text>

        {/* Peak annotation for ζ=0.1 */}
        {(() => {
          const z=0.1, rp=Math.sqrt(1-2*z*z), Dp=D(rp,z);
          return (
            <>
              <circle cx={mxF(rp)} cy={myA(Dp)} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
              <line x1={mxF(rp)} y1={myA(Dp)} x2={mxF(rp)+40} y2={myA(Dp)-22} stroke="#c0392b" strokeWidth="1" strokeDasharray="3"/>
              <text x={mxF(rp)+44} y={myA(Dp)-18} fontSize="10" fill="#c0392b" fontWeight="700">peak: r*=√(1−2ζ²)</text>
              <text x={mxF(rp)+44} y={myA(Dp)-4}  fontSize="10" fill="#c0392b">D_max=1/(2ζ√(1−ζ²))</text>
            </>
          );
        })()}

        {/* ── PHASE ──────────────────────────────── */}
        <rect x={50} y={272} width={445} height={108} rx={3} fill="#fafafa" stroke="#ddd"/>
        <text x={272} y={268} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Phase Angle φ(r,ζ)</text>

        {[0,90,180].map(deg=>(
          <g key={deg}>
            <line x1={50} y1={myP(deg*Math.PI/180)} x2={497} y2={myP(deg*Math.PI/180)} stroke={deg===90?"#bbb":"#ebebeb"} strokeWidth={deg===90?1.5:0.8} strokeDasharray={deg===90?"5,3":""}/>
            <text x={44} y={myP(deg*Math.PI/180)+4} textAnchor="end" fontSize="10" fill="#888">{deg}°</text>
          </g>
        ))}
        {[0,0.5,1,1.5,2,2.5].map(r=>(
          <g key={r}>
            <line x1={mxF(r)} y1={272} x2={mxF(r)} y2={380} stroke={r===1?"#c0392b":"#ebebeb"} strokeWidth={r===1?1.5:0.8} strokeDasharray={r===1?"6,3":""}/>
            <text x={mxF(r)} y={393} textAnchor="middle" fontSize="10" fill="#888">{r}</text>
          </g>
        ))}

        {/* Phase curves */}
        {ζs.map(({z,c})=>{
          const d=Array.from({length:nPts+1},(_,i)=>{
            const r=i/nPts*rMax;
            let p=phi(r,z);
            if(p<0)p+=Math.PI;
            return [r,p];
          }).map(([r,p],i)=>`${i===0?'M':'L'}${mxF(r).toFixed(1)},${myP(p).toFixed(1)}`).join(' ');
          return <path key={z} d={d} fill="none" stroke={c} strokeWidth="2"/>;
        })}

        {/* 90° at r=1 marker */}
        <circle cx={mxF(1)} cy={myP(Math.PI/2)} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
        <text x={mxF(1)+7} y={myP(Math.PI/2)-5} fontSize="10" fill="#c0392b" fontWeight="700">φ=90° for all ζ</text>

        <line x1={48} y1={272} x2={48} y2={382} stroke="#555" strokeWidth="1.5" markerEnd="url(#d5ax)"/>
        <line x1={46} y1={380} x2={500} y2={380} stroke="#555" strokeWidth="1.5" markerEnd="url(#d5ax)"/>
        <text x={272} y={398} textAnchor="middle" fontSize="11" fill="#555">frequency ratio  r = ω/ωₙ</text>

        {/* ── RIGHT: legend & formula panel ─────── */}
        <rect x={504} y={10} width={386} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={697} y={28} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Steady-State Formulas</text>

        {/* Legend */}
        {ζs.map(({z,c},i)=>(
          <g key={i}><line x1={512} y1={44+i*18} x2={536} y2={44+i*18} stroke={c} strokeWidth="3"/><text x={542} y={48+i*18} fontSize="11" fill={c} fontWeight="700">ζ = {z}</text></g>
        ))}

        {[
          {y:138, bg:'#FEF0F0', bc:'#c0392b', label:'Amplitude X',
           lines:['X = (F₀/k) · D(r,ζ)','D = 1/√[(1−r²)²+(2ζr)²]','r = ω/ωₙ,  static defl. = F₀/k']},
          {y:218, bg:'#eaf3ff', bc:'#2E75B6', label:'Phase angle φ',
           lines:['tan φ = 2ζr/(1−r²)','φ = 0° as r→0  (in-phase)','φ = 90° at r=1  (all ζ)','φ = 180° as r→∞']},
          {y:298, bg:'#f0fff4', bc:'#27ae60', label:'Peak amplitude',
           lines:['r* = √(1−2ζ²)  for ζ<1/√2','D_max = 1/(2ζ√(1−ζ²))','≈ 1/(2ζ) for small ζ','No peak if ζ ≥ 1/√2 ≈ 0.707']},
          {y:362, bg:'#fff5e6', bc:'#e07b00', label:'Quality factor Q',
           lines:['Q = D_max ≈ 1/(2ζ)','Bandwidth: Δr = 2ζ  (half-power)','Q = ωₙ/Δω  (measured from FRF)']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={510} y={y} width={374} height={lines.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={516} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={516} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        With damping, the resonance peak becomes finite with height ≈ 1/(2ζ) and shifts slightly below r=1 to r* = √(1−2ζ²). Phase transitions smoothly from 0° through 90° (always at r=1) to 180°. As ζ increases, the peak shortens and broadens; for ζ ≥ 1/√2 ≈ 0.707 the amplitude curve has no peak at all — it decreases monotonically from D=1 at r=0.
      </div>
    </div>
  );
}

// ── Diagram 6: Magnification Factor — Annotated ───────────────────
function DiagMagnification() {
  const W=900, H=340;
  const rMax=2.5, nPts=400;
  const D = (r,z) => 1/Math.sqrt((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r));
  const mx = r => 55+(r/rMax)*490;
  const myD = v => 50+(1-Math.min(v,7)/7)*220;

  const ζ=0.2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Magnification Factor — Annotated Key Points on the FRF</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="d6ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
          <marker id="d6r"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
          <marker id="d6b"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
        </defs>

        {/* Graph */}
        <rect x={50} y={45} width={500} height={240} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid */}
        {[0,1,2,3,4,5,6,7].map(v=>(
          <g key={v}>
            <line x1={50} y1={myD(v)} x2={552} y2={myD(v)} stroke={v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.8} strokeDasharray={v===1?"5,3":""}/>
            <text x={44} y={myD(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,0.5,1,1.5,2,2.5].map(r=>(
          <g key={r}>
            <line x1={mx(r)} y1={45} x2={mx(r)} y2={288} stroke="#ebebeb" strokeWidth="0.8"/>
            <text x={mx(r)} y={302} textAnchor="middle" fontSize="10" fill="#888">{r}</text>
          </g>
        ))}

        {/* Main curve (ζ=0.2) */}
        {(() => {
          const d=Array.from({length:nPts+1},(_,i)=>{const r=i/nPts*rMax;return [r,D(r,ζ)];})
            .map(([r,v],i)=>`${i===0?'M':'L'}${mx(r).toFixed(1)},${myD(v).toFixed(1)}`).join(' ');
          return <path d={d} fill="none" stroke="#c0392b" strokeWidth="3"/>;
        })()}

        {/* ① Static (r=0, D=1) */}
        <circle cx={mx(0)} cy={myD(1)} r={6} fill="#2E75B6" stroke="#fff" strokeWidth="2"/>
        <line x1={mx(0)} y1={myD(1)} x2={mx(0)-2} y2={myD(1)-36} stroke="#2E75B6" strokeWidth="1.5"/>
        <rect x={mx(0)-70} y={myD(1)-65} width={132} height={28} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={mx(0)+2} y={myD(1)-50} fontSize="11" fill="#2E75B6" fontWeight="700">① r=0: D=1 (static)</text>
        <text x={mx(0)+2} y={myD(1)-36} fontSize="10" fill="#444">X = F₀/k</text>

        {/* ② Peak */}
        {(() => {
          const rp=Math.sqrt(1-2*ζ*ζ), Dp=D(rp,ζ);
          return (
            <>
              <circle cx={mx(rp)} cy={myD(Dp)} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
              <line x1={mx(rp)} y1={myD(Dp)} x2={mx(rp)+40} y2={myD(Dp)-20} stroke="#c0392b" strokeWidth="1.5"/>
              <rect x={mx(rp)+42} y={myD(Dp)-35} width={180} height={32} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
              <text x={mx(rp)+48} y={myD(Dp)-20} fontSize="11" fill="#c0392b" fontWeight="700">② Peak: r*=√(1−2ζ²)={rp.toFixed(2)}</text>
              <text x={mx(rp)+48} y={myD(Dp)-6}  fontSize="10" fill="#444">D_max = 1/(2ζ√(1−ζ²)) = {Dp.toFixed(2)}</text>
            </>
          );
        })()}

        {/* ③ r=1, D=1/(2ζ) */}
        {(() => {
          const Dat1=D(1,ζ);
          return (
            <>
              <circle cx={mx(1)} cy={myD(Dat1)} r={6} fill="#9b59b6" stroke="#fff" strokeWidth="2"/>
              <line x1={mx(1)} y1={myD(Dat1)} x2={mx(1)+38} y2={myD(Dat1)+28} stroke="#9b59b6" strokeWidth="1.5"/>
              <rect x={mx(1)+40} y={myD(Dat1)+24} width={170} height={28} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
              <text x={mx(1)+46} y={myD(Dat1)+38} fontSize="11" fill="#9b59b6" fontWeight="700">③ r=1: D=1/(2ζ)={D(1,ζ).toFixed(2)}</text>
              <text x={mx(1)+46} y={myD(Dat1)+50} fontSize="10" fill="#444">Phase = 90° for all ζ</text>
            </>
          );
        })()}

        {/* ④ Half-power bandwidth */}
        {(() => {
          const Dp=D(1,ζ);
          const Dhp=Dp/Math.sqrt(2);
          // find r1, r2 numerically
          let r1=0,r2=0;
          for(let i=1;i<=nPts;i++){
            const ra=(i-1)/nPts*rMax, rb=i/nPts*rMax;
            const da=D(ra,ζ), db=D(rb,ζ);
            if(da<Dhp&&db>=Dhp&&ra<1)r1=rb;
            if(da>=Dhp&&db<Dhp&&ra>1)r2=ra;
          }
          return (
            <>
              <line x1={mx(r1)} y1={myD(Dhp)} x2={mx(r2)} y2={myD(Dhp)} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#d6r)"/>
              <line x1={mx(r2)} y1={myD(Dhp)} x2={mx(r1)} y2={myD(Dhp)} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#d6r)"/>
              <text x={(mx(r1)+mx(r2))/2} y={myD(Dhp)-8} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">④ Half-power BW: Δr = 2ζ = {(2*ζ).toFixed(2)}</text>
              <line x1={mx(r1)} y1={myD(0)} x2={mx(r1)} y2={myD(Dp)} stroke="#27ae60" strokeWidth="1" strokeDasharray="3"/>
              <line x1={mx(r2)} y1={myD(0)} x2={mx(r2)} y2={myD(Dp)} stroke="#27ae60" strokeWidth="1" strokeDasharray="3"/>
            </>
          );
        })()}

        {/* ⑤ Isolation (r=√2) */}
        {(() => {
          const rv=Math.sqrt(2), Dv=D(rv,ζ);
          return (
            <>
              <circle cx={mx(rv)} cy={myD(Dv)} r={5} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
              <line x1={mx(rv)} y1={myD(1)} x2={mx(rv)} y2={myD(0)} stroke="#e07b00" strokeWidth="1" strokeDasharray="4"/>
              <text x={mx(rv)+5} y={myD(Dv)+16} fontSize="10" fill="#e07b00" fontWeight="700">⑤ r=√2: D={Dv.toFixed(2)}&lt;1</text>
              <text x={mx(rv)+5} y={myD(Dv)+28} fontSize="10" fill="#e07b00">Isolation starts here</text>
            </>
          );
        })()}

        {/* Axes */}
        <line x1={48} y1={45} x2={48} y2={292} stroke="#555" strokeWidth="1.5" markerEnd="url(#d6ax)"/>
        <line x1={46} y1={myD(0)} x2={555} y2={myD(0)} stroke="#555" strokeWidth="1.5" markerEnd="url(#d6ax)"/>
        <text x={18} y={170} textAnchor="middle" fontSize="12" fill="#555" transform="rotate(-90,18,170)">D(r,ζ)</text>
        <text x={300} y={320} textAnchor="middle" fontSize="12" fill="#555">r = ω/ωₙ  [ζ = 0.2 shown]</text>

        {/* ── RIGHT ─── */}
        <rect x={562} y={10} width={328} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={726} y={26} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Magnification Factor Summary</text>
        {[
          {y:34,  c:'#2E75B6', n:'①', label:'Static  (r → 0)',      val:'D = 1'},
          {y:66,  c:'#c0392b', n:'②', label:'Resonance peak',       val:"D_max = 1/(2ζ√(1−ζ²))"},
          {y:98,  c:'#9b59b6', n:'③', label:'At r = 1',             val:'D = 1/(2ζ),  φ = 90°'},
          {y:130, c:'#27ae60', n:'④', label:'Half-power BW',        val:'Δr = 2ζ  →  ζ = Δr/2'},
          {y:162, c:'#e07b00', n:'⑤', label:'Isolation (r > √2)',   val:'D < 1  always'},
        ].map(({y,c,n,label,val})=>(
          <g key={y}>
            <circle cx={574} cy={y+16} r={10} fill={c}/>
            <text x={574} y={y+21} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{n}</text>
            <text x={590} y={y+14} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            <text x={590} y={y+28} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{val}</text>
          </g>
        ))}
        <rect x={566} y={205} width={318} height={120} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={572} y={221} fontSize="12" fill="#7B0D0D" fontWeight="700">Measuring ζ from FRF experiment:</text>
        <text x={572} y={237} fontSize="11" fill="#444">1. Read peak frequency → ωₙ ≈ ω_peak</text>
        <text x={572} y={253} fontSize="11" fill="#444">2. Read D_max</text>
        <text x={572} y={269} fontSize="11" fill="#444">3. Find ω₁, ω₂ where D = D_max/√2</text>
        <text x={572} y={285} fontSize="11" fill="#444">4. ζ = (ω₂−ω₁)/(2ωₙ)  [half-power method]</text>
        <text x={572} y={305} fontSize="11" fill="#555" fontStyle="italic">Works on measured data without a model</text>
        <text x={572} y={320} fontSize="11" fill="#555" fontStyle="italic">Most common experimental modal analysis technique</text>
      </svg>
      <div style={S.dCaption}>
        Five key points on the magnification factor curve for ζ=0.2: ① static limit D=1; ② amplitude peak at r*=√(1−2ζ²); ③ the point r=1 where D=1/(2ζ) and phase is always 90°; ④ the half-power bandwidth Δr=2ζ used to experimentally measure ζ; ⑤ the isolation threshold at r=√2 where D first falls below 1. The half-power method is the standard way to extract damping ratio from measured frequency response data.
      </div>
    </div>
  );
}

// ── Diagram 7: Rotating Imbalance ────────────────────────────────
function DiagRotatingImbalance() {
  const W=900, H=400;
  const nPts=400, rMax=3;
  const MX_me = (r,z) => r*r/Math.sqrt((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r));
  const mx = r => 55+(r/rMax)*460;
  const myV = v => 55+(1-Math.min(v,4)/4)*215;

  const ζs=[{z:0.05,c:'#9b59b6'},{z:0.1,c:'#c0392b'},{z:0.3,c:'#e07b00'},{z:0.7,c:'#27ae60'},{z:1.0,c:'#2E75B6'}];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Rotating Imbalance — Eccentric Mass Excitation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="d7ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
          <marker id="d7r"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
        </defs>

        {/* ── LEFT: physical model ─────────────── */}
        <rect x={10} y={10} width={270} height={380} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={145} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Physical Model</text>

        {/* Main mass M */}
        <rect x={45} y={130} width={200} height={130} rx={6} fill="#2E75B6" stroke="#1a5276" strokeWidth="2.5"/>
        <text x={145} y={190} textAnchor="middle" fontSize="20" fill="#fff" fontWeight="700">M − m</text>
        <text x={145} y={210} textAnchor="middle" fontSize="13" fill="#b3d4f5">(main body)</text>

        {/* Rotating disc */}
        <circle cx={145} cy={200} r={40} fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="5,3"/>
        {/* Eccentric mass dot */}
        {(() => {
          const angle=-0.6;
          const ex=145+35*Math.cos(angle), ey=200+35*Math.sin(angle);
          return (
            <>
              <line x1={145} y1={200} x2={ex} y2={ey} stroke="#e07b00" strokeWidth="2"/>
              <circle cx={ex} cy={ey} r={10} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
              <text x={ex+14} y={ey+4} fontSize="12" fill="#e07b00" fontWeight="700">m, e</text>
              <text x={ex-4} y={ey+5} fontSize="10" fill="#fff" fontWeight="700">m</text>
            </>
          );
        })()}
        <text x={145} y={240} textAnchor="middle" fontSize="11" fill="#e07b00">e = eccentricity</text>

        {/* Springs and ground */}
        <path d={mkSpring(18,45,195,6)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={31} y={178} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">k/2</text>
        <path d={mkSpring(245,272,195,6)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={258} y={178} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">k/2</text>
        <WallV x={6} y={165} h={60}/>
        <WallV x={260} y={165} h={60}/>

        {/* Vertical displacement */}
        <line x1={248} y1={130} x2={248} y2={260} stroke="#2E75B6" strokeWidth="2" strokeDasharray="5"/>
        <text x={256} y={198} fontSize="12" fill="#2E75B6" fontWeight="700">x(t)</text>

        {/* ω label */}
        <path d="M 160,200 A 15,15 0 1 0 175,187" fill="none" stroke="#c0392b" strokeWidth="2"/>
        <polygon points="175,187 183,183 178,193" fill="#c0392b"/>
        <text x={170} y={172} fontSize="13" fill="#c0392b" fontWeight="700">ω</text>

        {/* EOM */}
        <rect x={16} y={285} width={252} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={142} y={303} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">EOM (vertical)</text>
        <text x={20} y={320} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">Mẍ + cẋ + kx = meω²sin(ωt)</text>
        <text x={20} y={334} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">F₀ = meω²  (speed-dependent!)</text>

        {/* ── MIDDLE: amplitude plot ─────────── */}
        <rect x={290} y={10} width={280} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={430} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Amplitude Ratio  MX/(me)</text>

        {/* Graph area */}
        <rect x={300} y={40} width={262} height={235} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Grid */}
        {[0,1,2,3,4].map(v=>(
          <g key={v}>
            <line x1={300} y1={myV(v)} x2={562} y2={myV(v)} stroke={v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.8} strokeDasharray={v===1?"5,3":""}/>
            <text x={295} y={myV(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,1,2,3].map(r=>(
          <g key={r}>
            <line x1={300+r*460/3*1} y1={40} x2={300+r*460/3*1} y2={275} stroke="#ebebeb" strokeWidth="0.8"/>
            <text x={300+r*460/3*1} y={288} textAnchor="middle" fontSize="10" fill="#888">{r}</text>
          </g>
        ))}

        {/* Curves */}
        {ζs.map(({z,c})=>{
          const d=Array.from({length:nPts+1},(_,i)=>{
            const r=i/nPts*rMax;
            const x0=300, xw=262;
            const xp=x0+(r/rMax)*xw;
            const yp=myV(MX_me(r,z));
            return `${i===0?'M':'L'}${xp.toFixed(1)},${yp.toFixed(1)}`;
          }).join(' ');
          return <path key={z} d={d} fill="none" stroke={c} strokeWidth="2"/>;
        })}

        {/* Asymptote line MX/me=1 at high r */}
        <line x1={300} y1={myV(1)} x2={562} y2={myV(1)} stroke="#aaa" strokeWidth="1.2" strokeDasharray="6,3"/>
        <text x={565} y={myV(1)+4} fontSize="10" fill="#888">→1</text>

        <line x1={298} y1={40} x2={298} y2={278} stroke="#555" strokeWidth="1.5" markerEnd="url(#d7ax)"/>
        <line x1={296} y1={276} x2={565} y2={276} stroke="#555" strokeWidth="1.5" markerEnd="url(#d7ax)"/>
        <text x={430} y={298} textAnchor="middle" fontSize="11" fill="#555">r = ω/ωₙ</text>

        {/* High-r annotation */}
        <text x={475} y={myV(1)-10} fontSize="11" fill="#555" fontStyle="italic">r→∞: MX/me→1</text>

        {/* Legend */}
        {ζs.map(({z,c},i)=>(
          <g key={i}><line x1={306} y1={310+i*18} x2={326} y2={310+i*18} stroke={c} strokeWidth="2.5"/><text x={330} y={314+i*18} fontSize="11" fill={c} fontWeight="700">ζ={z}</text></g>
        ))}

        {/* ── RIGHT: formulas & notes ──────────── */}
        <rect x={580} y={10} width={310} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={735} y={28} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Key Equations</text>

        {[
          {y:36,  bg:'#FEF0F0', bc:'#c0392b', label:'Excitation force',
           lines:['F₀ = meω²','Grows with ω² — increases with speed!','m = unbalanced mass, e = eccentricity']},
          {y:120, bg:'#eaf3ff', bc:'#2E75B6', label:'Steady-state amplitude X',
           lines:['MX/(me) = r²/√[(1−r²)²+(2ζr)²]','= r² × D(r,ζ)','Compare: forced: D = 1/√[(1−r²)²+…]']},
          {y:204, bg:'#f0fff4', bc:'#27ae60', label:'High-speed limit',
           lines:['r→∞: MX/(me) → 1','X → me/M  (mass ratio × eccentricity)','Machine coasts above ωₙ to reach this']},
          {y:288, bg:'#fff5e6', bc:'#e07b00', label:'Peak amplitude',
           lines:['Peak at r* = 1/√(1−2ζ²)','MX_peak/(me) = 1/(2ζ√(1−ζ²))','Same formula as forced vibration peak']},
          {y:356, bg:'#f5d0ff', bc:'#9b59b6', label:'Applications',
           lines:['Motors, fans, turbines, engines','Rotating machinery must pass through ωₙ','Accelerate quickly; avoid lingering at ωₙ']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={586} y={y} width={298} height={lines.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={592} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={592} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Rotating imbalance is one of the most common sources of vibration in machinery. An eccentric mass m at radius e rotating at ω produces a centrifugal force F₀ = meω² that grows quadratically with speed. The amplitude ratio MX/(me) = r²·D(r,ζ) starts at zero (unlike harmonic forcing which starts at D=1), peaks near resonance, and approaches 1 at high speeds. Machines must pass through ωₙ during run-up — the key is to do so quickly so the transient has no time to build.
      </div>
    </div>
  );
}

// ── Diagram 8: Base Excitation ────────────────────────────────────
function DiagBaseExcitation() {
  const W=900, H=400;
  const nPts=400, rMax=3;
  const TR  = (r,z) => Math.sqrt((1+(2*z*r)*(2*z*r))/((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r)));
  const mx  = r => 55+(r/rMax)*460;
  const myT = v => 55+(1-Math.min(v,5)/5)*215;

  const ζs=[{z:0.05,c:'#9b59b6'},{z:0.1,c:'#c0392b'},{z:0.3,c:'#e07b00'},{z:0.7,c:'#27ae60'},{z:1.0,c:'#2E75B6'}];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Base Excitation &amp; Support Motion — Transmissibility TR</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="d8ax" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
          <marker id="d8r"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
          <marker id="d8g"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
          <marker id="d8o"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#e07b00"/></marker>
        </defs>

        {/* ── LEFT: model ─────────────────────── */}
        <rect x={10} y={10} width={258} height={380} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={139} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Base Excitation Model</text>

        {/* Mass */}
        <rect x={44} y={80} width={150} height={90} rx={6} fill="#2E75B6" stroke="#1a5276" strokeWidth="2.5"/>
        <text x={119} y={132} textAnchor="middle" fontSize="24" fill="#fff" fontWeight="700">m</text>

        {/* Spring */}
        <path d={mkSpring(30,118,218,7)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={74} y={202} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">k</text>

        {/* Damper */}
        <Damper x0={120} x1={215} y={218}/>
        <text x={167} y={202} textAnchor="middle" fontSize="13" fill="#888" fontWeight="700">c</text>

        {/* Connect spring/damper to mass bottom and base top */}
        <line x1={30}  y1={170} x2={30}  y2={248} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4"/>
        <line x1={215} y1={170} x2={215} y2={248} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4"/>
        <line x1={119} y1={170} x2={119} y2={218} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4"/>

        {/* Moving base */}
        <rect x={18} y={248} width={210} height={20} rx={3} fill="#888" stroke="#555" strokeWidth="2"/>
        <line x1={139} y1={270} x2={139} y2={295} stroke="#e07b00" strokeWidth="3" markerEnd="url(#d8r)"/>
        <text x={148} y={305} fontSize="12" fill="#e07b00" fontWeight="700">y(t)=Ysin(ωt)</text>

        {/* Fixed ground */}
        <line x1={12} y1={318} x2={262} y2={318} stroke="#555" strokeWidth="2"/>
        {[12,34,56,78,100,122,144,166,188,210,232,254].map(x=>(<line key={x} x1={x} y1={318} x2={x-12} y2={334} stroke="#555" strokeWidth="1.5"/>))}

        {/* x absolute displacement */}
        <line x1={200} y1={82} x2={200} y2={168} stroke="#2E75B6" strokeWidth="2" strokeDasharray="4"/>
        <line x1={195} y1={82}  x2={205} y2={82}  stroke="#2E75B6" strokeWidth="2"/>
        <line x1={195} y1={168} x2={205} y2={168} stroke="#2E75B6" strokeWidth="2"/>
        <text x={208} y={130} fontSize="12" fill="#2E75B6" fontWeight="700">x(t)</text>

        {/* z=x-y label */}
        <text x={139} y={68} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">z = x−y</text>

        {/* EOMs */}
        <rect x={14} y={340} width={240} height={44} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={134} y={356} textAnchor="middle" fontSize="10" fill="#7B0D0D" fontWeight="700">mẍ + c(ẋ−ẏ) + k(x−y) = 0</text>
        <text x={134} y={372} textAnchor="middle" fontSize="10" fill="#7B0D0D" fontWeight="700">mz̈ + cż + kz = −mÿ = mYω²sin(ωt)</text>

        {/* ── MIDDLE: TR plot ─────────────────── */}
        <rect x={278} y={10} width={295} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={425} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Transmissibility TR = X/Y</text>

        <rect x={288} y={38} width={277} height={238} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Shaded regions */}
        <rect x={288} y={38} width={mx(Math.sqrt(2))-288} height={238} fill="#fff5f5" opacity="0.5"/>
        <rect x={mx(Math.sqrt(2))} y={38} width={288+277-mx(Math.sqrt(2))} height={238} fill="#f0fff4" opacity="0.5"/>

        {/* Grid */}
        {[0,1,2,3,4,5].map(v=>(
          <g key={v}>
            <line x1={288} y1={myT(v)} x2={565} y2={myT(v)} stroke={v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.8} strokeDasharray={v===1?"5,3":""}/>
            <text x={283} y={myT(v)+4} textAnchor="end" fontSize="10" fill="#888">{v}</text>
          </g>
        ))}
        {[0,1,1.414,2,3].map(r=>(
          <g key={r}>
            <line x1={mx(r)} y1={38} x2={mx(r)} y2={276} stroke={r===1.414?"#27ae60":r===1?"#c0392b":"#ebebeb"} strokeWidth={r===1.414||r===1?1.5:0.8} strokeDasharray={r===1.414||r===1?"6,3":""}/>
            <text x={mx(r)} y={290} textAnchor="middle" fontSize="10" fill={r===1.414?"#27ae60":r===1?"#c0392b":"#888"}>{r===1.414?"√2":r}</text>
          </g>
        ))}

        {/* Curves */}
        {ζs.map(({z,c})=>{
          const d=Array.from({length:nPts+1},(_,i)=>{
            const r=i/nPts*rMax;
            const x0=288, xw=277;
            const xp=x0+(r/rMax)*xw;
            const yp=myT(TR(r,z));
            return `${i===0?'M':'L'}${xp.toFixed(1)},${yp.toFixed(1)}`;
          }).join(' ');
          return <path key={z} d={d} fill="none" stroke={c} strokeWidth="2"/>;
        })}

        {/* Region labels */}
        <text x={(288+mx(Math.sqrt(2)))/2} y={60} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">AMPLIFY</text>
        <text x={(mx(Math.sqrt(2))+565)/2} y={60} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">ISOLATE</text>
        <text x={(288+mx(Math.sqrt(2)))/2} y={74} textAnchor="middle" fontSize="10" fill="#c0392b">TR &gt; 1</text>
        <text x={(mx(Math.sqrt(2))+565)/2} y={74} textAnchor="middle" fontSize="10" fill="#27ae60">TR &lt; 1</text>

        <line x1={286} y1={38} x2={286} y2={278} stroke="#555" strokeWidth="1.5" markerEnd="url(#d8ax)"/>
        <line x1={284} y1={276} x2={568} y2={276} stroke="#555" strokeWidth="1.5" markerEnd="url(#d8ax)"/>
        <text x={425} y={310} textAnchor="middle" fontSize="11" fill="#555">r = ω/ωₙ</text>
        <text x={265} y={160} textAnchor="middle" fontSize="11" fill="#555" transform="rotate(-90,265,160)">TR</text>

        {/* Legend */}
        {ζs.map(({z,c},i)=>(
          <g key={i}><line x1={294} y1={325+i*16} x2={316} y2={325+i*16} stroke={c} strokeWidth="2.5"/><text x={320} y={329+i*16} fontSize="10" fill={c} fontWeight="700">ζ={z}</text></g>
        ))}

        {/* ── RIGHT: formulas & applications ──── */}
        <rect x={583} y={10} width={307} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={736} y={28} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Formulas &amp; Applications</text>

        {[
          {y:36,  bg:'#FEF0F0', bc:'#c0392b', label:'Transmissibility TR',
           lines:['TR = X/Y = √[(1+(2ζr)²)/((1−r²)²+(2ζr)²)]','Identical to force transmissibility','TR=1 at r=0 (all, always)','TR=1 at r=√2 (all, always)']},
          {y:132, bg:'#eaf3ff', bc:'#2E75B6', label:'Relative displacement z',
           lines:['Z/Y = r²·TR  (relative motion ampl.)','Needed for stress/clearance calc.','z → x as r → ∞ (mass stationary)']},
          {y:208, bg:'#f0fff4', bc:'#27ae60', label:'Isolation design',
           lines:['Want r > √2: use soft mounts (low ωₙ)','Better isolation: lower ωₙ (softer mount)','Compromise: lighter damping for isolation','but enough to survive resonance transit']},
          {y:284, bg:'#fff5e6', bc:'#e07b00', label:'Vehicle suspension',
           lines:['Road bumps → y(t); car body → x(t)','Soft springs: comfort (low ωₙ)','Stiff springs: handling (high ωₙ)','Real cars use semi-active dampers']},
          {y:348, bg:'#f5d0ff', bc:'#9b59b6', label:'Seismic isolation',
           lines:['Ground → y(t); building → x(t)','Lead-rubber bearings: fₙ ≈ 0.5 Hz','r ≈ 5–20 for 1–10 Hz quake content']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={589} y={y} width={295} height={lines.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={595} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={595} y={y+32+i*16} fontSize="11" fill="#444">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Base excitation converts support motion y(t) into body motion x(t). Transmissibility TR = X/Y is identical in form to force transmissibility and always equals 1 at r=√2 regardless of damping. Below √2 the mount amplifies; above √2 it isolates. The important (and counterintuitive) result at high r: adding more damping reduces isolation — so isolation mounts are intentionally lightly damped, with a snubber to limit resonance amplitude during startup.
      </div>
    </div>
  );
}

// ── Diagram 9: Response Comparison Summary ────────────────────────
function DiagSummaryComparison() {
  const W=900, H=300;
  const rMax=3, nPts=300;
  const D   = (r,z) => 1/Math.sqrt((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r));
  const RI  = (r,z) => r*r*D(r,z);
  const TRf = (r,z) => Math.sqrt((1+(2*z*r)*(2*z*r))/((1-r*r)*(1-r*r)+(2*z*r)*(2*z*r)));

  const mx  = (r,x0,w) => x0+(r/rMax)*w;
  const myV = (v,y0,h,vmax) => y0+h - (v/vmax)*h;

  const ζ=0.15;
  const panels=[
    {x:10, w:270, label:'Direct Force  D(r)',      fn:(r)=>D(r,ζ),   ymax:5, color:'#c0392b'},
    {x:300,w:270, label:'Rotating Imbalance MX/me',fn:(r)=>RI(r,ζ),  ymax:4, color:'#9b59b6'},
    {x:590,w:300, label:'Base Excitation TR',       fn:(r)=>TRf(r,ζ), ymax:5, color:'#2E75B6'},
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Side-by-Side Comparison — Three Excitation Types  [ζ = 0.15]</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {panels.map(({x,w,label,fn,ymax,color})=>{
          const gh=200, gy=45, gx=x+10;
          const d=Array.from({length:nPts+1},(_,i)=>{
            const r=i/nPts*rMax;
            const xp=mx(r,gx,w-20);
            const yp=myV(Math.min(fn(r),ymax),gy,gh,ymax);
            return `${i===0?'M':'L'}${xp.toFixed(1)},${yp.toFixed(1)}`;
          }).join(' ');

          return (
            <g key={x}>
              <rect x={x} y={10} width={w} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
              <text x={x+w/2} y={28} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{label}</text>
              <rect x={gx} y={gy} width={w-20} height={gh} rx={3} fill="#fafafa" stroke="#ddd"/>

              {/* y grid */}
              {[0,1,2,3,ymax].map(v=>(
                <g key={v}>
                  <line x1={gx} y1={myV(v,gy,gh,ymax)} x2={gx+w-20} y2={myV(v,gy,gh,ymax)} stroke={v===1?"#bbb":"#ebebeb"} strokeWidth={v===1?1.5:0.7} strokeDasharray={v===1?"4,3":""}/>
                  <text x={gx-4} y={myV(v,gy,gh,ymax)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
                </g>
              ))}
              {/* x grid */}
              {[0,1,2,3].map(r=>(
                <g key={r}>
                  <line x1={mx(r,gx,w-20)} y1={gy} x2={mx(r,gx,w-20)} y2={gy+gh} stroke="#ebebeb" strokeWidth="0.7"/>
                  <text x={mx(r,gx,w-20)} y={gy+gh+14} textAnchor="middle" fontSize="9" fill="#888">{r}</text>
                </g>
              ))}

              {/* r=1 line */}
              <line x1={mx(1,gx,w-20)} y1={gy} x2={mx(1,gx,w-20)} y2={gy+gh} stroke={color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>

              <path d={d} fill="none" stroke={color} strokeWidth="2.5"/>

              {/* r=0 value annotation */}
              {(() => {
                const v0=fn(0.01);
                return <text x={gx+6} y={myV(v0,gy,gh,ymax)-5} fontSize="10" fill={color} fontWeight="700">{v0<0.02?'→0':'=1'}</text>;
              })()}

              <text x={x+w/2} y={H-8} textAnchor="middle" fontSize="10" fill="#555">r = ω/ωₙ</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        Comparing the three excitation types side-by-side at ζ=0.15. Direct force excitation starts at D=1 (r=0) and peaks near r=1. Rotating imbalance starts at 0 (no force at zero speed) and asymptotes to MX/me=1 at high r. Base excitation transmissibility also starts at 1, peaks near resonance, then falls toward zero — but crucially, increased damping hurts isolation at high r (unlike the other two cases where more damping always helps at all frequencies).
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function ForcedVibration() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Forced Vibration — Undamped &amp; Damped SDOF Systems</h1>
      <p style={S.p}>
        Free vibration dies away unless energy is continuously supplied. In practice, machines, structures, and vehicles are subject to ongoing external excitation — harmonic forces from rotating machinery, periodic road roughness, or oscillating support structures. Forced vibration analysis answers two questions: what is the steady-state amplitude and phase of the response at a given forcing frequency, and how does the system behave as the forcing frequency sweeps through the natural frequency (resonance)? This page covers both the undamped and damped cases, plus two important practical variants: rotating imbalance and base excitation.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "EOM: mẍ + cẋ + kx = F₀cos(ωt)  —  total solution = homogeneous (free) + particular (forced)",
        "Particular solution: x_p = X cos(ωt−φ)  with  X = (F₀/k)·D(r,ζ)  and  r = ω/ωₙ",
        "Magnification factor: D(r,ζ) = 1/√[(1−r²)²+(2ζr)²]  —  undamped: D = 1/(1−r²)",
        "Resonance: ω = ωₙ (r=1) → undamped amplitude → ∞; phase = 90° for all ζ at r=1",
        "Peak amplitude: D_max = 1/(2ζ√(1−ζ²)) at r* = √(1−2ζ²);  Q = 1/(2ζ)",
        "Half-power bandwidth: Δr = 2ζ  →  experimental measurement of ζ from FRF",
        "Rotating imbalance: F₀ = meω²; amplitude ratio MX/(me) = r²·D(r,ζ) → 1 at high r",
        "Base excitation TR = X/Y = √[(1+(2ζr)²)/((1−r²)²+(2ζr)²)]; isolation for r > √2",
      ]}/>

      {/* ─────────────── SECTION 5 ─────────────── */}
      <h2 style={S.h2}>§5 — Forced Vibration (Undamped)</h2>

      <h2 style={S.h2}>Harmonic Excitation &amp; Solution Structure</h2>
      <p style={S.p}>
        When a harmonic force F(t) = F₀cos(ωt) is applied to an undamped SDOF system, the equation of motion mẍ + kx = F₀cos(ωt) is a second-order non-homogeneous ODE. Its complete solution is the sum of two parts: the homogeneous solution x_h — free oscillation at the natural frequency ωₙ set by initial conditions — and the particular solution x_p — a forced oscillation at the applied frequency ω. Because there are two different frequencies present simultaneously, the combined response exhibits a beating pattern that grows more dramatic as ω approaches ωₙ.
      </p>
      <DiagUndampedSetup/>
      <Table2 rows={[
        ["Particular solution","x_p(t) = X cos(ωt)  where  X = (F₀/k)/(1 − r²)\nr = ω/ωₙ  (frequency ratio)\nValid only when r ≠ 1 (non-resonant case)"],
        ["Homogeneous solution","x_h(t) = A cos(ωₙt) + B sin(ωₙt)\nA, B fixed by initial conditions x₀ and ẋ₀\nOscillates at natural frequency ωₙ, independent of forcing"],
        ["Complete solution (r≠1)","x(t) = A cos(ωₙt) + B sin(ωₙt) + (F₀/k)·cos(ωt)/(1−r²)\nWith rest ICs (x₀=0, ẋ₀=0): A = −X, B = 0\nx(t) = X[cos(ωt) − cos(ωₙt)]  — classic beating form"],
        ["Beating frequency","ω_beat = |ωₙ − ω|  (rad/s)\nT_beat = 2π/|ωₙ−ω|  (period of amplitude envelope)\nAs ω → ωₙ, T_beat → ∞ (slower and slower beats)"],
        ["Superposition validity","Only valid for LINEAR systems\nDamping does not affect particular solution frequency\nBut transient (homogeneous) dies away with damping → steady state only"],
      ]}/>

      <h2 style={S.h2}>Beating Phenomenon</h2>
      <DiagBeating/>

      <h2 style={S.h2}>Resonance Condition</h2>
      <p style={S.p}>
        When the forcing frequency exactly equals the natural frequency (ω = ωₙ, r = 1), the denominator of the particular solution 1 − r² equals zero and the standard formula breaks down. A separate derivation using the method of undetermined coefficients gives the resonance solution x(t) = (F₀/2mωₙ)·t·sin(ωₙt) — a sinusoid whose amplitude grows linearly without bound. The 90° phase lag at resonance is a fundamental result that holds for all values of damping, making it the most reliable experimental indicator of the natural frequency.
      </p>
      <DiagResonance/>
      <Table2 rows={[
        ["Resonance solution","x(t) = (F₀/2mωₙ)·t·sin(ωₙt)\nAmplitude envelope = (F₀/2mωₙ)·t  (linear growth)\nOnly valid at exact resonance ω = ωₙ"],
        ["Phase at resonance","φ = 90° exactly at r = 1 for ALL values of ζ\nBest experimental indicator of ωₙ — independent of damping\nMeasure where phase crosses 90° to find ωₙ"],
        ["Physical interpretation","At resonance, force is always perpendicular to velocity\nForce does maximum work per cycle → energy pumped in every cycle\nWith no damping, energy accumulates indefinitely"],
        ["Avoiding resonance","Detune: change ωₙ = √(k/m) by adjusting k or m\nAdd damping: limits peak even at resonance\nRun-through: for machines, accelerate quickly past ωₙ\nDynamic absorber: add secondary mass-spring tuned to ωₙ"],
        ["Historical examples","Tacoma Narrows Bridge (1940): aeroelastic flutter near ωₙ\nMillennium Bridge London (2000): crowd-induced synchronous walking\nTurbomachinery blade fatigue: engine order crossings at ωₙ"],
      ]}/>

      <h2 style={S.h2}>Undamped Frequency Response</h2>
      <DiagUndampedFRF/>
      <Table2 rows={[
        ["Undamped magnification D(r)","D(r) = 1/(1−r²)\nr < 1: D > 0 (in-phase, spring-controlled)\nr > 1: D < 0 (180° out-of-phase, mass-controlled)\nVertical asymptote at r = 1"],
        ["Static deflection","At r = 0: D = 1 → X = F₀/k\nResponse equals the static deflection under load F₀\nSystem has time to follow force quasi-statically"],
        ["High-frequency limit","r → ∞: D → 0\nMass cannot respond quickly enough to follow forcing\nAmplitude vanishes: isolation at high frequencies"],
        ["Effect of adding damping","Asymptote at r=1 replaced by finite peak 1/(2ζ)\nPhase jump at r=1 replaced by smooth 0°→180° transition\nRegions r<1 and r>1 qualitatively unchanged"],
      ]}/>

      {/* ─────────────── SECTION 6 ─────────────── */}
      <div style={S.divider}/>
      <h2 style={S.h2}>§6 — Forced Vibration With Damping</h2>

      <h2 style={S.h2}>Steady-State Amplitude &amp; Phase</h2>
      <p style={S.p}>
        With viscous damping included, the particular (steady-state) solution to mẍ + cẋ + kx = F₀cos(ωt) is x_p = X cos(ωt−φ), where the amplitude X and phase φ both depend on the frequency ratio r and damping ratio ζ. Unlike the undamped case, the resonance peak is now finite (height ≈ 1/(2ζ)) and occurs slightly below r = 1. The phase transitions smoothly from 0° through 90° at r = 1 to 180° as r increases. The 90° crossing at r = 1 is independent of damping and remains the best experimental indicator of ωₙ.
      </p>
      <DiagDampedFRF/>
      <Table2 rows={[
        ["Steady-state amplitude X","X = (F₀/k)·D(r,ζ)\nD = 1/√[(1−r²)²+(2ζr)²]\nAt r=0: D=1;  at r=1: D=1/(2ζ);  as r→∞: D→0"],
        ["Phase angle φ","tan φ = 2ζr/(1−r²)\nφ = 0° (r→0, in-phase)\nφ = 90° (r=1, all ζ — quarter cycle lag)\nφ = 180° (r→∞, out-of-phase)"],
        ["Steady-state vs transient","Transient decays as e^(−ζωₙt) — disappears after ~4/(ζωₙ) seconds\nSteady-state persists indefinitely\nMeasured vibration = steady-state only after transient dies"],
        ["Effect of damping on peak","D_max = 1/(2ζ√(1−ζ²)) at r*=√(1−2ζ²)\nFor ζ < 0.1: D_max ≈ 1/(2ζ)  (peak ≈ at r=1)\nFor ζ = 0.707: D_max = 1 (flat response, no peak)\nFor ζ > 0.707: amplitude decreases monotonically"],
        ["Imaginary/complex form","X·e^{jφ} = (F₀/k)/[(1−r²)+j(2ζr)]\nReal part: amplitude;  imaginary part: phase\nFrequency Response Function H(ω) = 1/(k−mω²+jcω)"],
      ]}/>

      <h2 style={S.h2}>Magnification Factor</h2>
      <p style={S.p}>
        The magnification factor D(r,ζ) summarises all the key features of the damped FRF into one dimensionless plot. Five key points are annotated: the static limit, the amplitude peak, the resonance phase point, the half-power bandwidth (used to measure ζ experimentally), and the vibration isolation threshold. Understanding these five points is sufficient to read any measured FRF and extract the system's natural frequency, damping ratio, and static stiffness.
      </p>
      <DiagMagnification/>
      <Table2 rows={[
        ["Peak amplitude","r* = √(1−2ζ²) — slightly below r=1\nD_max = 1/(2ζ√(1−ζ²))\nFor ζ=0.05: D_max=10.0;  ζ=0.1: D_max=5.03;  ζ=0.3: D_max=1.75"],
        ["Half-power method for ζ","Find ω₁, ω₂ where amplitude = D_max/√2 (power = half peak)\nζ = (ω₂−ω₁)/(2ωₙ) = Δω/(2ωₙ)\nMost common experimental damping measurement technique"],
        ["Quality factor Q","Q = 1/(2ζ) = D_max at r=1 (approx.)\nQ = ωₙ/(ω₂−ω₁)  (from bandwidth measurement)\nHigh Q = lightly damped, narrow sharp peak"],
        ["3 regions of FRF","r ≪ 1: spring-controlled (D≈1, X≈F₀/k)\nr ≈ 1: damping-controlled (D≈1/(2ζ) at peak)\nr ≫ 1: mass-controlled (D→0, X→F₀/(mω²))"],
        ["Nyquist (circle) plot","Im(H) vs Re(H) traces a circle for SDOF\nDiameter = 1/(cωₙ);  ωₙ at top of circle\nUsed in modal testing to separate closely-spaced modes"],
      ]}/>

      <h2 style={S.h2}>Rotating Imbalance</h2>
      <p style={S.p}>
        Rotating imbalance is the dominant source of vibration in motors, fans, pumps, turbines, and internal combustion engines. An eccentric mass m at radius e (eccentricity) rotating at angular speed ω generates a centrifugal force F₀ = meω² that increases quadratically with rotational speed. This replaces the constant-amplitude harmonic force with a speed-dependent one, which changes the shape of the amplitude-ratio curve: it now starts at zero (no force at standstill) and approaches a constant MX/me = 1 at high speeds.
      </p>
      <DiagRotatingImbalance/>
      <Table2 rows={[
        ["Excitation force","F₀ = meω² = me(rωₙ)²\nGrows quadratically with speed — machines accelerate into resonance\nm = imbalance mass, e = radius of imbalance"],
        ["Amplitude ratio MX/(me)","MX/(me) = r²/√[(1−r²)²+(2ζr)²]\n= r² × D(r,ζ)\nZero at r=0; peak near r=1; → 1 at r→∞"],
        ["High-speed asymptote","r→∞: MX/(me) → 1\nX → me/M (independent of speed!)\nBalancing reduces me product directly"],
        ["Peak value","Same formula as direct forcing peak:\nMX_peak/(me) = 1/(2ζ√(1−ζ²))"],
        ["Balancing","Static balancing: add/remove mass to make centre of mass on rotation axis\nDynamic balancing: also correct couple imbalance (two-plane)\nISO 1940: balance quality grades G0.4 → G40"],
        ["Run-up strategy","Rotate quickly through resonance to limit transient build-up\nSlow run-through can be more damaging than steady resonant operation\nSoft-start VFD drives: controlled acceleration rate"],
      ]}/>

      <h2 style={S.h2}>Base Excitation &amp; Support Motion</h2>
      <p style={S.p}>
        In base excitation problems, the support point moves with prescribed displacement y(t) = Y sin(ωt) and the mass responds with x(t). The forcing appears as constraint forces transmitted through the spring and damper rather than as a direct applied force. Reformulating in terms of relative displacement z = x − y reduces the problem to the standard forced vibration form, with the effective force being the inertial force −mÿ = mYω²sin(ωt). The key output is transmissibility TR = X/Y, which has exactly the same formula as force transmissibility.
      </p>
      <DiagBaseExcitation/>
      <Table2 rows={[
        ["Base excitation EOM","mẍ + c(ẋ−ẏ) + k(x−y) = 0\nAbsolute: mẍ + cẋ + kx = cẏ + ky\nRelative (z=x−y): mz̈+cż+kz = −mÿ = mYω²sin(ωt)"],
        ["Displacement TR  X/Y","TR = √[(1+(2ζr)²)/((1−r²)²+(2ζr)²)]\nTR=1 at r=0 and r=√2 for all ζ\nTR>1 for r<√2 (amplification)  TR<1 for r>√2 (isolation)"],
        ["Acceleration TR  Ẍ/Ÿ","Same formula as X/Y\nIsolation of accelerations equally important (sensitive equipment, people)"],
        ["Relative displacement Z/Y","Z/Y = r²·TR  (same as rotating imbalance ratio)\nNeeded to design clearance gaps; calculate strain in spring/damper"],
        ["Counterintuitive damping effect","At r > √2: more damping reduces isolation\nTR_high_r ≈ 2ζ/r² for large r\nOptimum: low damping + snubbers to limit resonance amplitude\nContrasts with direct force excitation (damping always helps there)"],
        ["Seismic isolation","Lead-rubber bearings or friction pendulum isolators\nfₙ ≈ 0.3–0.5 Hz  (period 2–3 s)\nFor 1–10 Hz earthquake content: r = 2–30 → excellent isolation\nUsed: hospitals, data centres, nuclear plants"],
      ]}/>

      <h2 style={S.h2}>Comparison of All Three Excitation Types</h2>
      <DiagSummaryComparison/>
      <Table2 rows={[
        ["Direct harmonic force","F = F₀cos(ωt) — constant amplitude\nD(0)=1, peak near r=1, D→0 as r→∞\nStatic deflection visible at r=0"],
        ["Rotating imbalance","F = meω² — amplitude grows with ω²\nD(0)=0, peak near r=1, D→1 as r→∞\nBoth amplitude and phase shift through resonance"],
        ["Base excitation","y(t)=Ysin(ωt) — prescribed support motion\nTR(0)=1, peak near r=1, TR→0 as r→∞\nAt r=√2: TR=1 regardless of ζ"],
        ["Common features","All three: resonance near r=1, phase=90° at r=1\nAll three: damping reduces peak amplitude\nAll three: ζ measured by half-power bandwidth"],
        ["Key differences at high r","Direct force: D→0 (mass filters input)\nRotating: MX/me→1 (eccentricity only)\nBase TR→0 but more damping hurts isolation"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "EOM:  mẍ + cẋ + kx = F₀cos(ωt)   |   r = ω/ωₙ   |   ζ = c/(2mωₙ)",
        "Undamped particular:  X = (F₀/k)/(1−r²)  [r≠1]   |   Resonance:  x(t) = (F₀/2mωₙ)·t·sin(ωₙt)",
        "Damped steady-state:  X = (F₀/k)·D(r,ζ)   D = 1/√[(1−r²)²+(2ζr)²]",
        "Phase:  tan φ = 2ζr/(1−r²)   |   φ = 90° at r=1 for ALL ζ",
        "Peak:  D_max = 1/(2ζ√(1−ζ²))  at  r* = √(1−2ζ²)",
        "Quality factor:  Q = 1/(2ζ)   |   Half-power BW:  ζ = (ω₂−ω₁)/(2ωₙ)",
        "Rotating imbalance:  MX/(me) = r²·D(r,ζ)   →  1  as r→∞",
        "Base excitation TR:  TR = √[(1+(2ζr)²)/((1−r²)²+(2ζr)²)]   |   Isolation: r > √2",
        "Relative disp. (base):  Z/Y = r²·TR   |   Force TR = displacement TR (same formula)",
      ]}/>
    </div>
  );
}